// src/utils/ws.ts
import { API_BASE_URL } from "../api/http";

export const getWSUrl = (endpoint: string): string => {
  const base = API_BASE_URL
    ? API_BASE_URL.replace(/^http/, "ws")
    : `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}`;

  return `${base}${endpoint}`;
};
